if (!customElements.get('shop-all-subcategory-slider')) {
  class ShopAllSubcategorySlider extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-subcategory-scroller]');
      this.previousButton = this.querySelector('[data-subcategory-previous]');
      this.nextButton = this.querySelector('[data-subcategory-next]');

      if (!this.scroller) return;

      this.onPrevious = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      this.onScroll = this.updateButtons.bind(this);
      this.onResize = this.updateButtons.bind(this);

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.scroller?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    scroll(direction) {
      const card = this.scroller.querySelector('.shop-all-subcategories__item');
      const gap = Number.parseFloat(window.getComputedStyle(this.scroller).columnGap) || 0;
      const distance = card ? (card.getBoundingClientRect().width + gap) * 3 : this.scroller.clientWidth * 0.8;

      this.scroller.scrollBy({
        left: direction * distance,
        behavior: 'smooth',
      });
    }

    updateButtons() {
      const maxScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const hasOverflow = maxScroll > 2;

      if (this.previousButton) {
        this.previousButton.hidden = !hasOverflow;
        this.previousButton.disabled = this.scroller.scrollLeft <= 2;
      }

      if (this.nextButton) {
        this.nextButton.hidden = !hasOverflow;
        this.nextButton.disabled = this.scroller.scrollLeft >= maxScroll - 2;
      }
    }
  }

  customElements.define('shop-all-subcategory-slider', ShopAllSubcategorySlider);
}
